export const organizeRawTextIntoBits = (text, previousBitsRenderedArray = []) => {
  const bits = [];
  let currentBit = [];
  let currentJoke = [];
  const lines = text.split('\n');

  // Helper function to unpack a joke object into its full text form (setup + punchline + taglines)
  const unpackJokeObjectToText = (jokeObject) => {
    const setupText = jokeObject.setup.join('\n');
    const punchlineText = jokeObject.punchline.text;
    const taglinesText = jokeObject.taglines.map(tagline => tagline.punchline.text).join('\n');
    return setupText + '\n' + punchlineText + (taglinesText ? '\n' + taglinesText : '');
  };

  lines.forEach((line) => {
    const isBitDivider = line.startsWith('***');
    const isEmptyLine = line.trim().length === 0;

    if (isBitDivider) {
      if (currentJoke.length > 0) {
        currentBit.push(currentJoke.join('\n'));
        currentJoke = [];
      }
      if (currentBit.length > 0) {
        bits.push([...currentBit]);
        currentBit = [];
      }
    } else if (isEmptyLine) {
      if (currentJoke.length > 0) {
        currentBit.push(currentJoke.join('\n'));
        currentJoke = [];
      }
    } else {
      currentJoke.push(line);
    }
  });

  if (currentJoke.length > 0) {
    currentBit.push(currentJoke.join('\n'));
  }
  if (currentBit.length > 0) {
    bits.push([...currentBit]);
  }

  // Iterate through bits and check for matching jokes in previousBitsRenderedArray
  const updatedBits = bits.map((bit, bitIndex) => {
    return bit.map((jokeText, jokeIndex) => {
      const previousBit = previousBitsRenderedArray[bitIndex];

      if (previousBit) {
        const matchedJokeObject = previousBit.find((prevJoke) => {
          // Unpack the joke object to its full text and compare
          if (typeof prevJoke === 'object') {
            const previousJokeText = unpackJokeObjectToText(prevJoke);
            return previousJokeText === jokeText; // Compare the full joke text with the current joke text
          }
          return false;
        });

        // If a matching object is found, replace the text with the object
        if (matchedJokeObject) {
          console.log(`Matching joke found, replacing joke text with object at bit[${bitIndex}][${jokeIndex}]`);
          return matchedJokeObject;
        }
      }

      // If no match is found, return the joke text as it is
      return jokeText;
    });
  });

  return updatedBits;
};
